import { render, staticRenderFns } from "./edit-delivery-staff.vue?vue&type=template&id=d477a83c&"
import script from "./edit-delivery-staff.vue?vue&type=script&lang=js&"
export * from "./edit-delivery-staff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports